import script from "./Slices.vue?vue&type=script&setup=true&lang=js"
export * from "./Slices.vue?vue&type=script&setup=true&lang=js"

import "./Slices.vue?vue&type=style&index=0&id=e9c19a5e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9c19a5e"]])

export default __exports__